export default __webpack_public_path__ + "static/media/JHU_IncidentCases_County.f9c3153b.csv";